import { render, staticRenderFns } from "./AllUsers.vue?vue&type=template&id=80a9c512&"
import script from "./AllUsers.vue?vue&type=script&lang=ts&"
export * from "./AllUsers.vue?vue&type=script&lang=ts&"
import style0 from "./AllUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports